/**
 * CheTuo Web — 平台超级管理员登录页 (用户名/手机号 + 密码).
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { passwordLogin } from '../../api/auth';
import { useAuth } from '../../hooks/useAuth';
import { ApiError } from '../../api/client';

export function AdminLoginPage(): React.JSX.Element {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!phone || !password) {
      setError('请输入用户名/手机号和密码');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const res = await passwordLogin(phone, password);
      if (!res.user.isSuperAdmin) {
        setError('该账号不是超级管理员，无法登录平台后台');
        setLoading(false);
        return;
      }
      login(res.token, res.user);
      navigate('/admin/dashboard');
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : '登录失败';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-center text-2xl">车妥</CardTitle>
          <p className="text-center text-sm text-[#64748B]">平台管理后台</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">用户名/手机号</label>
              <Input
                type="text"
                placeholder="请输入超级管理员手机号/用户名"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                maxLength={20}
                autoComplete="username"
              />
            </div>
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">密码</label>
              <Input
                type="password"
                placeholder="请输入密码"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                maxLength={128}
                autoComplete="current-password"
              />
            </div>
            {error && <p className="text-sm text-red-600">{error}</p>}
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? '登录中...' : '登录'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
